import { render, staticRenderFns } from "./Sellers.vue?vue&type=template&id=6ae2464a&scoped=true&"
import script from "./Sellers.vue?vue&type=script&lang=js&"
export * from "./Sellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae2464a",
  null
  
)

export default component.exports